import { Receipt, PromiseToPay } from "@/types/payments";

/**
 * Detect if a receipt matches a Promise to Pay
 * 
 * Matching criteria:
 * - Date within ±2 days
 * - Amount within ±£1
 * - Promise status is Pending or Partially Paid
 */
export function detectPromise(
  receipt: Receipt,
  customerPromises: PromiseToPay[]
): PromiseToPay | null {
  const receiptDate = new Date(receipt.receiptDate);
  const receiptAmount = receipt.receivedAmount;

  for (const promise of customerPromises) {
    // Check if promise is active
    if (promise.status !== "Pending" && promise.status !== "Partially Paid") {
      continue;
    }

    // Check date match (±2 days tolerance)
    const promiseDate = new Date(promise.promisedDate);
    const daysDiff = Math.abs(
      (receiptDate.getTime() - promiseDate.getTime()) / (1000 * 60 * 60 * 24)
    );

    if (daysDiff > 2) continue;

    // Check amount match (±£1 tolerance)
    const amountDiff = Math.abs(receiptAmount - promise.promisedAmount);

    if (amountDiff > 1) continue;

    // Match found!
    return promise;
  }

  return null;
}
